import Dialog from "@material-ui/core/Dialog";
import { FormattedMessage } from "react-intl";

import "./CustomDialog.scss";
import * as React from "react";

export interface CustomDialogProps {
  open: boolean;
  titleIntlId: string;
  onClose: () => void;
  code: string;
}

const CustomDialog = ({
  open,
  titleIntlId,
  onClose,
  code,
}: CustomDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: "CustomDialog-root" }}>
      <div className="CustomDialog-header">
        <FormattedMessage id={titleIntlId} />
      </div>
      <div className="password-container">
        <div className="password-letter">{code && code[0]}</div>
        <div className="password-space">-</div>
        <div className="password-letter">{code && code[1]}</div>
        <div className="password-space">-</div>
        <div className="password-letter">{code && code[2]}</div>
        <div className="password-space">-</div>
        <div className="password-letter">{code && code[3]}</div>
        <div className="password-space">-</div>
        <div className="password-letter">{code && code[4]}</div>
      </div>
      <div className="description">
        <FormattedMessage id="Password_Modal_Description"/>
      </div>
    </Dialog>
  );
};

export { CustomDialog };
